import type { ImgHTMLAttributes } from "react";

type AppImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  src: string;
  alt: string;
  priority?: boolean;
};

export function AppImage({ priority: _priority, loading, ...props }: AppImageProps) {
  return <img loading={loading ?? "lazy"} {...props} />;
}
